import Seo from "@/components/Seo";
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import Portfolio from "@/components/Portfolio";
import CTABand from "@/components/CTABand";
import { useLang } from "@/lib/i18n";

export default function WorksPage() {
  const { lang } = useLang();
  return (
    <div className="bg-[#050505] min-h-screen">
      <Seo
        title={lang === "zh" ? "演出作品 — DFE 娛樂夢工廠" : "Works — Dream Factory Entertainment"}
        description={lang === "zh" ? "DFE 演出作品集：BLACK EYED PEAS、DAESUNG、TAEYANG、YE 演唱会，FLAMEWAVE、Borneo Sonic 等音乐节，以及商业演出与音乐制作。" : "DFE portfolio: BLACK EYED PEAS, DAESUNG, TAEYANG, YE concerts; FlAmewave, Borneo Sonic and more festivals; corporate shows and music production."}
      />
      <NavBar />
      <main className="pt-16">
        <Portfolio />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
